<div *ngIf="global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000'">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--  -->

<div *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''  && global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">

    <div class="row text-end mb-4">
        <div class="col-lg-12">
            <button class="btn blue-btn btn-sm mr-2" *ngIf="!expandorCollapseall" (click)="ExpandAll()">
                Expand All</button>
            <button class="btn blue-btn btn-sm mr-2" *ngIf="expandorCollapseall" (click)="CollapesAll()">
                Collapse All</button>
        </div>
    </div>
    <!-- Coming Due Authorization Chart -->
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt p-2" style=" color: #502189;">Coming Due Authorization Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expand2()" *ngIf="EXPBOOL2" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand2()" *ngIf="!EXPBOOL2" class="transition"><i class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!EXPBOOL2">
                    <div class="w-100 h-300p">
                        <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme" [results]="auth"
                            [gradient]="gradient" (select)="onSelect($event)">
                        </ngx-charts-advanced-pie-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row mb-0">
                        <div class="col-5  headertxt p-2">
                            <h5 style=" color: #502189;">Pending UMPI Chart</h5>
                        </div>
                        <div class="col-7 mt-2 text-center headertxt">
                            <h5 style=" color: #502189;">Employee List</h5>
                        </div>
                    </div>
                    <div class="widget-controls">
                        <a (click)="expand1()" *ngIf="EXPBOOL1" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand1()" *ngIf="!EXPBOOL1" class="transition"><i class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!EXPBOOL1">

                    <div class="row w-100">
                        <div class="col-lg-6 mb-4">

                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme1" [results]="multi"
                                [gradient]="gradient" (select)="onSelect1($event)">
                            </ngx-charts-advanced-pie-chart>

                        </div>
                        <div class="col-lg-6 mt-1">

                            <div class="control-section mt-5">
                                <ejs-grid #grid [dataSource]='data|async' [allowSorting]='true'
                                    [pageSettings]='initialPage' [filterSettings]='filterSettings'
                                    [allowResizing]='true' [allowPaging]='true' [allowFiltering]='true'
                                    (dataStateChange)='dataChangeDashBoard($event)'
                                    (actionBegin)="onActionComplete($event)" (rowSelected)="gotoempDetails($event)"
                                    [showColumnChooser]="true">
                                    <e-columns>
                                        <e-column minWidth=100 field='name' [allowFiltering]="false"
                                            headerText='Employee' textAlign='left' width=100 type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <!-- <e-column minWidth=100 field='month' headerText='Month' textAlign='left'
                                                            width=100 [allowFiltering]="false"> </e-column>
                                                        <e-column minWidth=100 field='exceededHours' headerText='Exceeded Hrs'
                                                            textAlign='left' width=100 [allowFiltering]="false"> </e-column>
                                                        <e-column minWidth=100 field='totalhours' headerText='Total Hrs'
                                                            textAlign='left' width=100 [allowFiltering]="false"> </e-column> -->
                                        <e-column minWidth=100 field='email' headerText='Email' textAlign='left'
                                            width=100 type="string" [allowFiltering]="false">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field='phone1' headerText='Phone' textAlign='left'
                                            [allowFiltering]="false" width=100 type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column width="20" [showInColumnChooser]='false'>
                                            <ng-template #headerTemplate let-data>
                                                <div>
                                                    <span id='show' (click)='showDashBoardColumn()'><i
                                                            class="fa fa-cog fa-lg" aria-hidden="true">
                                                        </i></span>
                                                </div>
                                            </ng-template>
                                        </e-column>
                                    </e-columns>
                                </ejs-grid>

                                <div *ngIf="empdata.length == 0" class="text-center" style="color:red">
                                    <p>No data available</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- EIN Chart -->
    <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row mb-0">
                        <div class="col-5  headertxt p-2">
                            <h5 style=" color: #502189;">Clients Without EIN {{!einBool && einLength != 0 ? '(' +
                                einLength + ')' : ''}}</h5>
                        </div>
                    </div>
                    <div class="widget-controls">
                        <a (click)="expandEIN()" *ngIf="einBool" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expandEIN()" *ngIf="!einBool" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!einBool">

                    <div class="row w-100">
                        <div class="col-lg-12">

                            <div class="control-section">
                                <ejs-grid #eingrid [dataSource]='EINData | async' [allowSorting]='true'
                                    [pageSettings]='initialPageEIN' [filterSettings]='filterSettingsEIN'
                                    [allowResizing]='true' [allowPaging]='true' [allowFiltering]='true'
                                    (dataStateChange)='dataChangeEIN($event)'
                                    (actionBegin)="onActionCompleteEIN($event)"
                                    (rowSelected)="gotoClientDetailsEIN($event)" [showColumnChooser]="true">
                                    <e-columns>
                                        <e-column minWidth=100 field='name' [allowFiltering]="false" headerText='Client'
                                            textAlign='left' width=100 type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field='email' headerText='Email' textAlign='left'
                                            width=100 type="string" [allowFiltering]="false">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field='phone1' headerText='Phone' textAlign='left'
                                            [allowFiltering]="false" width=100 type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column width="20" [showInColumnChooser]='false'>
                                            <ng-template #headerTemplate let-data>
                                                <div>
                                                    <span id='show' (click)='showDashBoardColumn()'><i
                                                            class="fa fa-cog fa-lg" aria-hidden="true">
                                                        </i></span>
                                                </div>
                                            </ng-template>
                                        </e-column>
                                    </e-columns>
                                </ejs-grid>

                                <div *ngIf="eindata.length == 0" class="text-center" style="color:red">
                                    <p>No data available</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Program Type -->
    <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row mb-0">
                        <div class="col-5  headertxt p-2">
                            <h5 style=" color: #502189;">Program Type Chart</h5>
                        </div>
                        <div class="col-7 text-center mt-2 headertxt">
                            <h5 style=" color: #502189;">Client List</h5>
                        </div>
                    </div>
                    <div class="widget-controls">
                        <a (click)="expandPgmType()" *ngIf="pgmTypeBool" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expandPgmType()" *ngIf="!pgmTypeBool" class="transition"><i
                                class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!pgmTypeBool">

                    <div class="row w-100">
                        <div class="col-lg-5 mb-4">

                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="pgmTypeColorScheme"
                                [results]="pgmTypeChartList" [gradient]="gradient" (select)="onSelectPgmType($event)">
                            </ngx-charts-advanced-pie-chart>

                        </div>
                        <div class="col-lg-7 mt-1">

                            <div class="control-section mt-5">
                                <ejs-grid #pgmtypegrid [dataSource]='PGMTypeData | async' [allowSorting]='true'
                                    [pageSettings]='initialPagePgmType' [filterSettings]='filterSettingsPgmType'
                                    [allowResizing]='true' [allowPaging]='true' [allowFiltering]='true'
                                    (dataStateChange)='dataChangePgmType($event)'
                                    (actionBegin)="onActionCompletePgmType($event)"
                                    (rowSelected)="gotoClientDetailsPT($event)" [showColumnChooser]="true">
                                    <e-columns>
                                        <e-column minWidth=100 field='name' [allowFiltering]="false" headerText='Client'
                                            textAlign='left' width=100 type="string">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field='email' headerText='Email' textAlign='left'
                                            width=100 type="string" [allowFiltering]="false">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column minWidth=100 field='programType' headerText='Program Type'
                                            textAlign='left' width=100 type="string" [allowFiltering]="false">
                                            <ng-template #filterTemplate let-data>
                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                </ejs-maskedtextbox>
                                            </ng-template>
                                        </e-column>
                                        <e-column width="20" [showInColumnChooser]='false'>
                                            <ng-template #headerTemplate let-data>
                                                <div>
                                                    <span id='show' (click)='showDashBoardColumn()'><i
                                                            class="fa fa-cog fa-lg" aria-hidden="true">
                                                        </i></span>
                                                </div>
                                            </ng-template>
                                        </e-column>
                                    </e-columns>
                                </ejs-grid>

                                <div *ngIf="pgmtypedata.length == 0" class="text-center" style="color:red">
                                    <p>No data available</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Claim  Chart -->
    <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt p-2" style=" color: #502189;">Claim Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expand3()" *ngIf="EXPBOOL3" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand3()" *ngIf="!EXPBOOL3" class="transition"><i class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!EXPBOOL3">
                    <div class="w-100 ">

                        <div class="row ">

                            <div class="col-lg-6">
                                <h5 class="mb-0 headertxt" style=" color: #502189;"> Active</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                    [results]="Active87PClaimcount" [gradient]="gradient"
                                    (select)="claimselect($event,'active',false)">


                                </ngx-charts-advanced-pie-chart>
                            </div>
                            <div class="col-lg-6">
                                <!-- <h5 class="mb-0 headertxt" style=" color: #004290;"> Active 837I Claims</h5>
                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                [results]="Archeive87PClaimcount" [gradient]="gradient"
                                (select)="claimselect($event,'archive',false)"> -->

                                <h5 class="mb-0 headertxt" style=" color: #502189;"> Archived</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                    [results]="Archeive87PClaimcount" [gradient]="gradient"
                                    (select)="claimselect($event,'archive',false)">


                                </ngx-charts-advanced-pie-chart>
                            </div>
                        </div>


                        <!--                 
                    <div class="row ">

                        <div class="col-lg-6">
                            <h5 class="mb-0 headertxt" style=" color: #004290;"> Archived 837P Claims</h5>
                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                [results]="Archeive87PClaimcount" [gradient]="gradient"
                                (select)="claimselect($event,'ArchiveClaims',false)">


                            </ngx-charts-advanced-pie-chart>
                        </div>
                        <div class="col-lg-6">
                            <h5 class="mb-0 headertxt " style=" color: #004290;"> Archived 837I Claims</h5>
                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                [results]="Archeive87IClaimcount" [gradient]="gradient"
                                (select)="claimselect($event,'ArchiveClaims',true)">


                            </ngx-charts-advanced-pie-chart>
                        </div>
                    </div>
     -->


                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Claim Amount Chart -->
    <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0 headertxt p-2" style=" color: #502189;">Claim Amount Chart</h5>
                    <div class="widget-controls">
                        <a (click)="expand4()" *ngIf="EXPBOOL4" class="transition"><i
                                class="fa fa-chevron-down"></i></a>
                        <a (click)="expand4()" *ngIf="!EXPBOOL4" class="transition"><i class="fa fa-chevron-up"></i></a>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!EXPBOOL4">
                    <div class="w-100 ">




                        <div class="row">
                            <div class="col-lg-6">
                                <h5 class="mb-0 headertxt" style=" color: #502189;"> Active</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                    [results]="Active87PClaimAmount" [gradient]="gradient"
                                    (select)="claimselect($event,'active',false)">
                                </ngx-charts-advanced-pie-chart>
                            </div>
                            <div class="col-lg-6">
                                <!-- <h5 class="mb-0 headertxt" style=" color: #004290;"> Active 837I Claims Amount</h5>
                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                [results]="Archeive87PClaimAmount" [gradient]="gradient"
                                (select)="claimselect($event,'archive',false)"> -->
                                <h5 class="mb-0 headertxt" style=" color: #502189;"> Archived</h5>
                                <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                    [results]="Archeive87PClaimAmount" [gradient]="gradient"
                                    (select)="claimselect($event,'archive',false)">

                                </ngx-charts-advanced-pie-chart>
                            </div>

                        </div>

                        <!-- .............. -->
                        <!-- <div class="row">
                        <div class="col-lg-6">
                            <h5 class="mb-0 headertxt" style=" color: #004290;"> Archived 837P Claims Amount</h5>
                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                [results]="Archeive87PClaimAmount" [gradient]="gradient"
                                (select)="claimselect($event,'ArchiveClaims',false)">
                            </ngx-charts-advanced-pie-chart>
                        </div>
                        <div class="col-lg-6">
                            <h5 class="mb-0 headertxt" style=" color: #004290;"> Archived 837I Claims Amount</h5>
                            <ngx-charts-advanced-pie-chart class="mychart" [scheme]="colorScheme"
                                [results]="Archeive87IClaimAmount" [gradient]="gradient"
                                (select)="claimselect($event,'ArchiveClaims',true)">
                            </ngx-charts-advanced-pie-chart>
                        </div>

                    </div> -->




                    </div>
                </div>
            </div>
        </div>
    </div>

    <!----------------------------------------- Excluded Employees ------------------------------>
    <div class="row">
        <div class="col-12 mb-4">
            <div widget class="card border-0 box-shadow widget">
                <div class="card-header transparent border-0 text-muted">
                    <div class="row">
                        <div class="col-lg-8 col-sm-12 col-md-12">
                            <h5 class="mb-0 headertxt p-2" style=" color: #502189;">Excluded Employees</h5>
                        </div>
                        <span class="col-lg-2 col-sm-6 text-sm-start text-lg-end">


                            <button class="btn btn-sm" (click)="openOig()"> OIG
                                Analysis</button>
                        </span>
                        <div class="col-lg-2 col-sm-6  text-end">
                            <a (click)="expandExcludedAuth()" *ngIf="Excludedbool" class="transition"><i
                                    class="fa fa-chevron-down"></i></a>
                            <a (click)="expandExcludedAuth()" *ngIf="!Excludedbool" class="transition"><i
                                    class="fa fa-chevron-up"></i></a>
                        </div>
                    </div>
                </div>
                <div class="card-body widget-body" *ngIf="!Excludedbool">


                    <div class="col">
                        <div class="row mt-3"></div>
                        <div class="control-section">
                            <ejs-grid #gridOig [dataSource]='dataExcluded | async' [allowSorting]='true'
                                [allowResizing]='true' [allowPaging]='true' [allowFiltering]='true'
                                (dataStateChange)='dataStateChangeOIG($event)' (actionBegin)="OnactionBeginOIG($event)"
                                [pageSettings]='initialPage1' [filterSettings]='filterOptions'>
                                <e-columns>
                                    <e-column field="name" headerText="Name" type='string' width=140
                                        [allowFiltering]='false'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="dob" headerText="DOB" type='date' [allowFiltering]='false'
                                        [format]='formatOptions' width=100>
                                    </e-column>
                                    <e-column field="age" headerText="Age" [allowFiltering]='false' type='number'>
                                    </e-column>
                                    <e-column field="email" headerText="Email" [allowFiltering]='false' type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="phone1" headerText="Phone" [allowFiltering]='false' type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="phone2" headerText="Phone 2" [allowFiltering]='false'
                                        type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="street" headerText="Street" [allowFiltering]='false' type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="zipcode" headerText="ZIP Code" [allowFiltering]='false'
                                        type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="statusLidName" headerText="Status" [allowFiltering]='false'
                                        type='string'>
                                        <ng-template #filterTemplate let-data>
                                            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                        </ng-template>
                                    </e-column>

                                </e-columns>
                            </ejs-grid>

                            <div *ngIf="ExcludedEmployeesList == 0" class="text-center" style="color:red">
                                <p>No data available</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<span id="openReportModal" data-bs-toggle="modal" data-bs-target="#viewReport"></span>
<div class="modal fade " id="viewReport" data-bs-backdrop="static">
    <div class="modal-dialog modal-fullscreen" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Coming Due Authorization Report</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="closemodal()">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <ng-container *ngIf="reportcontain== true">
                    <div style="width: 100%;height:100%" #reportContainer></div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<app-client-create-edit *ngIf="EditData" (EventToEdit)="dataEmitfromChild($event)"></app-client-create-edit>